export const environment = {
  production: false,
  defaultToken: "",
  builderApiKey: "6336f9fc0d2e4508967511ce706e655f",
  // Google reCAPTCHA v3 - public by design; it is bound to the allowed domains in the
  // reCAPTCHA admin console, and Midgard holds the matching secret.
  recaptchaSiteKey: "6LfdLREuAAAAAIjLALryOLjq9OaAj5WJLY3RB_CK",
};
